import {
  GetLaunchWorkflowsByRequesterInput,
  LaunchWorkflowData,
} from "@amzn/coral_com-amazon-deviceslaunchcontrolservice";
import { AppThunk } from "../app/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getLaunchWorkflowsByRequester } from "../app/api";
import { isHydratedIdentity } from "../userInfo/userInfoSlice";

interface OclSubmissionToolsState {
  items: LaunchWorkflowData[];
  isGettingLaunchWorkflowsForUser: boolean;
}

const OclSubmissionToolsInitialState: OclSubmissionToolsState = {
  items: [],
  isGettingLaunchWorkflowsForUser: true,
};

const oneClickLaunchSubmissionToolsControl = createSlice({
  name: "oneClickLaunchSubmissionToolsControl",
  initialState: OclSubmissionToolsInitialState,
  reducers: {
    setGettingLaunchWorkflowsForUser(state, action: PayloadAction<boolean>) {
      state.isGettingLaunchWorkflowsForUser = action.payload;
    },
    setItemsForUser(state, action: PayloadAction<LaunchWorkflowData[]>) {
      state.items = action.payload;
    },
  },
});

export const { setGettingLaunchWorkflowsForUser, setItemsForUser } =
  oneClickLaunchSubmissionToolsControl.actions;

export default oneClickLaunchSubmissionToolsControl.reducer;

/**
 * The requester identity comes from `/get-user`, so a caller that renders before
 * that response lands would send `identity: ""`, which the service rejects with
 * a 400.
 */
export function hasRequesterIdentity(
  input: GetLaunchWorkflowsByRequesterInput
): boolean {
  return isHydratedIdentity(input?.requester?.identity);
}

export const fetchLaunchWorkflowsByRequester =
  (input: GetLaunchWorkflowsByRequesterInput): AppThunk =>
  async (dispatch) => {
    // Never send an identity we do not have yet. The loading flag is left
    // untouched so the caller keeps its pending state until the identity
    // arrives and it retries.
    if (!hasRequesterIdentity(input)) {
      console.log(
        "Skipping getLaunchWorkflowsByRequester: requester identity is not hydrated yet"
      );
      return;
    }
    try {
      dispatch(setGettingLaunchWorkflowsForUser(true));
      const result = await getLaunchWorkflowsByRequester(input);
      dispatch(setItemsForUser(result.results as LaunchWorkflowData[]));
      dispatch(setGettingLaunchWorkflowsForUser(false));
    } catch (err: any) {
      dispatch(setGettingLaunchWorkflowsForUser(false));
      console.log(err);
    }
  };
